export default __webpack_public_path__ + "98ee573366de4041714880aa23de5e9d.png";